import { useLocation, useNavigate } from 'react-router-dom';
import Navigation from './Navigation'
import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setMenuListAssetInventory } from 'Store/AssetInventory/Navigation/NavigationAction';
import { ASSET_INVENTORY_CONSTANTS } from 'client/utils/constants/assetInventory';

const NavigationContainer = () => {

    const ref: any = useRef(null)
    const path = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const pathName = path?.pathname?.split("/")[2];

    // const { menuListAssetInventory}: any = useSelector((state?: any) => ({
    //   menuListAssetInventory: state.AssetInventoryNavReducer.menuListAssetInventory,
    // }));

    const menuListActiveAsset = [
        {
            "id": 1,
            "text": "ActiveAsset",
            "Item": "activeasset",
            "icon": "activeAsset-icon",
            "Title": "Active Assets",
            "activeToggle": true
        },
        // {
        //     "id": 2,
        //     "text": "Users",
        //     "Item": "users",
        //     "icon": "users-icon",
        //     "Title": "Users",
        //     "activeToggle": false
        // }
    ]

    let menuList = [
        {
            id: 1,
            text: 'ActiveAsset',
            Item: 'activeasset',
            icon: 'activeAsset-icon',
            Title: 'Active Assets',
            activeToggle: true
        },
        // {
        //   id:2,
        //   text: 'Users',
        //   Item: 'users',
        //   icon: 'users-icon',
        //   Title: 'Users',
        //   activeToggle: false
        // }
    ]

    useEffect(() => {
        dispatch(setMenuListAssetInventory(menuList))
    }, [])

    const handleClick = (dataItem: any) => {

        if (dataItem.Item === 'question') {
            navigate('assetinventory')
        }
        else {
            navigate('assetinventory/' + dataItem.Item)
        }

        menuListActiveAsset.forEach((item: any) => {
            if (item.text === dataItem.text) {
                item.activeToggle = true
            }
            else {
                item.activeToggle = false
            }
        })

    }

    useEffect(() => {
        if (pathName === ASSET_INVENTORY_CONSTANTS.USERS && menuListActiveAsset?.length) {
            menuListActiveAsset.forEach((item: any) => {
                return (
                    item.id == 2 ? item.activeToggle = true : item.activeToggle = false
                )
            })
        } else if (pathName === ASSET_INVENTORY_CONSTANTS.AUDIT_DATES && menuListActiveAsset?.length) {
            menuListActiveAsset.forEach((item: any) => {
                return (
                    item.id == 3 ? item.activeToggle = true : item.activeToggle = false
                )
            })
        } else if (pathName === ASSET_INVENTORY_CONSTANTS.MERGER_AND_ACQUISITION && menuListActiveAsset?.length) {
            menuListActiveAsset.forEach((item: any) => {
                return (
                    item.id == 4 ? item.activeToggle = true : item.activeToggle = false
                )
            })
        } else {
            menuListActiveAsset.forEach((item: any) => {
                return (
                    item.id == 1 ? item.activeToggle = true : item.activeToggle = false
                )
            })
        }
    }, [pathName, menuListActiveAsset])

    return <Navigation
        handleClick={handleClick}
        menuListActiveAsset={menuListActiveAsset}
        wrapperRef={ref}
    />

}

export default NavigationContainer
